<template>
    <transition name="fade" mode="out-in">
        <div v-if="isLoading" 
            key="skeleton"
            class="w-100"
        >
            <slot name="skeleton"></slot>      
        </div>
        <div v-else 
            key="component"
            class="w-100"
        >
            <slot name="content"></slot>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "SkeletonWrapper",
        components: {},
        props: {
            isLoading: Boolean
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>